import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../components/primitives/Panel';
import type { ContactRow } from '../outreachTypes';
import { ContactRowView } from './ContactRowView';
import { contactsMessages as messages } from './contactsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Contacts.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ContactsTableProps {
  accountId: number;
  rows: ContactRow[];
  selected: ReadonlySet<string>;
  onToggle: (uuid: string) => void;
  onOpen: (uuid: string) => void;
}

/** The contacts table (design outreach-v2 k1): who, email, last pitched, last result. */
const ContactsTableComponent: React.FC<ContactsTableProps> = ({ accountId, rows, selected, onToggle, onOpen }) => {
  const intl = useIntl();
  const items = useMemo(
    () =>
      rows.map((row) => (
        <ContactRowView
          key={row.workspaceContactUuid}
          accountId={accountId}
          row={row}
          selected={selected.has(row.workspaceContactUuid)}
          onToggle={onToggle}
          onOpen={onOpen}
        />
      )),
    [accountId, onOpen, onToggle, rows, selected]
  );
  return (
    <Panel as="section">
      <div className={shared.table} data-testid="contacts-table">
        <div className={clsx(shared.tableRow, shared.tableHead, styles.contactRow)}>
          <span />
          <span />
          <span>{intl.formatMessage(messages.colName)}</span>
          <span className="d-none d-md-block">{intl.formatMessage(messages.colEmail)}</span>
          <span className="d-none d-md-block">{intl.formatMessage(messages.colLastPitched)}</span>
          <span>{intl.formatMessage(messages.colStatus)}</span>
        </div>
        {items}
      </div>
    </Panel>
  );
};

export const ContactsTable = TypedMemo(ContactsTableComponent);
